import React, { useState, useEffect } from "react";
const NCSCUpdateTrade = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [dataaa, setdata] = useState("")
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),
        GenderTotal3: 0,
        GenderTotalVIEW: 0,
        GenderMale4: 0,
    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }

        await fetch(process.env.REACT_APP_API_LINK +'api/NCSCDA/GetNcscDaDetails', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    setFormData({
                        GenderTotal3: maindata.genderTotal3,
                        GenderMale4: maindata.genderMale4,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }

        await fetch(process.env.REACT_APP_API_LINK +'api/NCSCDA/UpdateDetailsNcscDa', {
            method: 'POST',
            headers: {  
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => //console.log(data))
                    setdata(data))
        props.setGTotal(props.GTotal + 1)
    };

    




    useEffect(() => {
        getdata()

    }, [props.Change])


    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

    return (
            load?null: <>
                <tr scope="row"  >
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} > {(props.index - 8) / 100 + 4}{(props.index - 8) % 10 === 0 ? 0 : null}</td>
             
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >{props.name}</td>

                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="genderMale4"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="genderMale4"
                            style={{ textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.GenderMale4}
                        /> : formData.GenderMale4}

                    </td>
                </tr>

            </>

        
         

      
            
          
    );
};

export default NCSCUpdateTrade;
